var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightningFilled = function SvgLightningFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 2C14.75 1.6695 14.5337 1.37795 14.2173 1.28218C13.901 1.1864 13.5593 1.30898 13.376 1.58397L5.37596 13.584C5.22254 13.8141 5.20823 14.11 5.33875 14.3539C5.46926 14.5978 5.7234 14.75 6 14.75H10.25V22C10.25 22.3305 10.4663 22.622 10.7827 22.7178C11.099 22.8136 11.4407 22.691 11.624 22.416L19.624 10.416C19.7775 10.1859 19.7918 9.88997 19.6613 9.6461C19.5307 9.40224 19.2766 9.25 19 9.25H14.75V2Z"
  })));
};
export default SvgLightningFilled;